(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.pre-suitability-quiz-previously-failed', [
    'pp.widgets-templates',
    'pp.services.route'
]);

ngModule.component('ppPreSuitabilityQuizPreviouslyFailed', {
    templateUrl: 'widgets/_angular/pre-suitability-quiz-previously-failed/pre-suitability-quiz-previously-failed.tpl.html',
    bindings: {
        onContinue: '&',
        quizType: '<',
        attemptsRemaining: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', 'routeService', function ($scope, routeService) {
        var vm = this;

        vm.imHomeNow = routeService.imHomeNow;
        vm.kidHomeNow = routeService.kidHomeNow;
        vm.keyRisksUrl = routeService.keyRisksUrl;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);